<template>
    <div>
        <div class="modal fade modern-modal" id="ModalProcessoNorma" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            @click="cancelar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                            <path d="M16,15H9V13H16V15M19,11H9V9H19V11M19,7H9V5H19V7M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3M21,1A2,2 0 0,1 23,3V17C23,18.11 22.11,19 21,19H7A2,2 0 0,1 5,17V3C5,1.89 5.89,1 7,1H21M7,3V17H21V3H7Z" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Normativas do Processo</h2>
                            <p>Selecione as normativas que serão utilizadas neste processo.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="form-group">
                            <label for="buscar-normativa" class="form-label">Buscar normativa</label>
                            <div class="search-input">
                                <span class="search-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <input id="buscar-normativa"
                                       v-model="pagFilter"
                                       type="text"
                                       class="form-control"
                                       placeholder="Digite o nome do arquivo ou normativa" />
                            </div>
                        </div>

                        <div v-if="lstNormasProcesso.length"
                             class="normas-list"
                             :class="{ 'normas-list--limite': lstNormasProcesso.length >= 5 }">
                            <label class="norma-card"
                                   :class="{
                                       'norma-card--selected': item.fUtilizada,
                                       'norma-card--disabled': isNormaBloqueada(item)
                                   }"
                                   v-for="(item, index) in lstNormasProcesso"
                                   :key="index">
                                <input class="norma-checkbox"
                                       type="checkbox"
                                       :disabled="isNormaBloqueada(item)"
                                       v-model="item.fUtilizada" />

                                <div class="norma-card__indicator"
                                     :class="{
                                         'is-selected': item.fUtilizada,
                                         'is-disabled': isNormaBloqueada(item)
                                     }">
                                    <span class="indicator-icon">
                                        <svg v-if="item.fUtilizada" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                            <path d="M7.75 13.25L4.5 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.75 13.25L15.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>

                                <div class="norma-card__body">
                                    <div class="norma-card__title">
                                        {{ item.norma.dsNome }}
                                    </div>
                                    <div class="norma-card__meta" v-if="nomeArquivoNorma(item.norma) && item.norma.nmNorma">
                                        {{ nomeArquivoNorma(item.norma) }}
                                    </div>
                                </div>

                                <div class="norma-card__status" v-if="isNormaBloqueada(item) && !modoVisualizacao">
                                    <span class="tag tag-warning">Processando</span>
                                </div>
                            </label>
                        </div>

                        <div v-else class="empty-state">
                            <div class="empty-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9 21H15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M19 12C19 10.4087 18.3679 8.88258 17.2426 7.75736C16.1174 6.63214 14.5913 6 13 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 9V12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <h5>Nenhuma normativa encontrada</h5>
                                <p>Refine a busca ou verifique se há normativas disponíveis para este processo.</p>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-footer" v-if="!modoVisualizacao">
                        <button type="button" class="btn btn-modern-primary w-100" @click="salvar">Salvar seleções</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalProcessoNorma',
        props: {
            showModal: Boolean,
            idProcesso: String,
            dsNome: String,
            dsProcesso: String,
            modoVisualizacao: Boolean,
        },
        data() {
            return {
                lstNormasProcesso: [],
                pagFilter: '',
                debounceTimeout: null,
                myModalAlternative: null,
            }
        },
        computed: {
            lstNormas() {
                return this.$store.state.lstNormas
            },
        },
        methods: {
            isNormaBloqueada(item) {
                if (this.modoVisualizacao) return true;
                if (!item?.processoNorma) return false;
                const normativa = item.processoNorma;
                return normativa.idProcessoNorma > 0 && !normativa.flEnviado && (!normativa.fileId || normativa.fileId === '');
            },

            nomeArquivoNorma(norma) {
                if (norma?.nmArquivo) return norma.nmArquivo;
                if (norma?.urlArquivo) {
                    const partes = String(norma.urlArquivo).split('/');
                    const ultimo = partes[partes.length - 1];
                    if (ultimo) return ultimo;
                }
                return '';
            },

            cancelar() {
                this.lstNormasProcesso = [];
                if (this.myModalAlternative) {
                    this.myModalAlternative.hide();
                }
                this.$emit('close');
            },

            async salvar() {
                let $this = this;
                try {
                    let response = await axios.post(`${urlApi}/ProcessoNorma/Post`, $this.lstNormasProcesso);

                    if (response.data.success) {
                        avisoToast("Normativas salvas com sucesso.");
                        $this.getProcessoNormas();
                        //this.cancelar();
                        //this.$emit('nome-alterado');
                    } else {
                        avisoErro(response.data.msg || "Erro ao salvar normativas.");
                    }
                } catch (error) {
                    avisoErro("Erro ao comunicar com o servidor.");
                }
            },

            getProcessoNormas(filterValue) {
                let $this = this;
                const filtro = typeof filterValue === 'string' ? filterValue.trim() : ($this.pagFilter || '').trim();

                axios.get(`${urlApi}/ProcessoNorma/GetNormasProcesso`, {
                    params: {
                        idProcesso: $this.idProcesso,
                        filter: filtro,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstNormasProcesso = res.data.data;
                            for (let i = 0; i < $this.lstNormasProcesso.length; i++) {
                                let item = $this.lstNormasProcesso[i].norma;

                                const arquivo = $this.nomeArquivoNorma(item);
                                item.dsNome = item.nmNorma || arquivo || 'Normativa sem nome definido';

                                $this.lstNormasProcesso[i].norma = item;
                            }
                            
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar normativas do processo.')
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar normativas do processo!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                    });
            },

            reprocessar(formProcessoNorma) {
                let $this = this;
                axios.post(`${urlApi}/ProcessoNorma/Reprocessar`, formProcessoNorma)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Normativa reprocessada.");
                            $this.getProcessoNormas();
                        } else {
                            avisoErro("Não foi possível reprocessar a normativa.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível reprocessar a normativa.");
                        }
                    });
            },
        },

        beforeDestroy() {
            if (this.debounceTimeout) clearTimeout(this.debounceTimeout)
        },
        mounted() {
            this.myModalAlternative = new window.bootstrap.Modal('#ModalProcessoNorma');
            const modalEl = document.getElementById('ModalProcessoNorma');

            modalEl.addEventListener('hidden.bs.modal', () => {
                this.$emit('close');
            });

            this.getProcessoNormas();
        },
        watch: {
            showModal(newValue) {
                if (newValue) {
                    this.getProcessoNormas(this.pagFilter);
                    if (this.myModalAlternative) {
                        this.myModalAlternative.show();
                    }
                } else if (this.myModalAlternative) {
                    this.myModalAlternative.hide();
                }
            },

            pagFilter: {
                handler() {
                    clearTimeout(this.debounceTimeout)
                    this.debounceTimeout = setTimeout(() => {
                        this.getProcessoNormas(this.pagFilter)
                    }, 500)
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    :deep(.modern-modal) {
        .modal-modern-content {
            border-radius: 20px;
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
            position: relative;
        }

        .modal-modern-header {
            display: flex;
            align-items: flex-start;
            gap: 18px;
            padding: 32px 32px 20px;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 32px;
                right: 32px;
                height: 1px;
                background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
            }

            .header-icon {
                width: 60px;
                height: 60px;
                border-radius: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(96, 165, 250, 0.18) 0%, rgba(14, 165, 233, 0.18) 100%);
                color: #2563eb;
            }

            .header-text {
                h2 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 700;
                    color: #0f172a;
                }

                p {
                    margin-top: 6px;
                    margin-bottom: 0;
                    color: #475569;
                    font-size: 14px;
                    max-width: 460px;
                    line-height: 1.5;
                }
            }
        }

        .modal-modern-body {
            padding: 28px 32px 24px;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }

        .modal-modern-footer {
            padding: 0 32px 32px;
        }

        .form-group {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .form-label {
            font-weight: 600;
            color: #0f172a;
            font-size: 13px;
            letter-spacing: 0.3px;
            text-transform: uppercase;
        }

        .form-control {
            border-radius: 12px;
            border: 2px solid rgba(148, 163, 184, 0.2);
            background: #ffffff;
            padding: 12px 16px;
            font-size: 14px;
            color: #1f2937;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                border-color: rgba(37, 99, 235, 0.6);
                box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
                background: #ffffff;
                color: #0f172a;
            }
        }

        .search-input {
            position: relative;
            display: flex;
            align-items: center;

            .search-icon {
                position: absolute;
                left: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #838b99;
            }

            .form-control {
                padding-left: 46px;
            }
        }

        .normas-list {
            display: grid;
            gap: 16px;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        }

        .normas-list--limite {
            grid-template-columns: repeat(5, minmax(0, 1fr));
        }

        .norma-card {
            position: relative;
            display: flex;
            flex-direction: row;
            gap: 16px;
            border-radius: 16px;
            border: 1.5px solid rgba(148, 163, 184, 0.25);
            background: rgba(255, 255, 255, 0.9);
            padding: 18px 20px;
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 16px 32px rgba(37, 99, 235, 0.1);
                border-color: rgba(59, 130, 246, 0.45);
            }

            &--selected {
                border-color: rgba(59, 130, 246, 0.55);
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(56, 189, 248, 0.12) 100%);
                box-shadow: 0 14px 36px rgba(59, 130, 246, 0.18);
            }

            &--disabled {
                cursor: not-allowed;
                opacity: 0.75;
                border-style: dashed;
            }

            .norma-card__indicator {
                width: 36px;
                min-width: 36px;
                height: 36px;
                border-radius: 10px;
                border: 2px solid rgba(148, 163, 184, 0.45);
                display: flex;
                align-items: center;
                justify-content: center;
                color: #2563eb;
                background: rgba(248, 250, 252, 0.92);
                transition: all 0.2s ease;

                &.is-selected {
                    border-color: rgba(59, 130, 246, 0.65);
                    background: rgba(59, 130, 246, 0.16);
                    color: #1d4ed8;
                }

                &.is-disabled {
                    border-style: dashed;
                    color: #a1a1aa;
                }

                .indicator-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .norma-card__body {
                display: flex;
                flex-direction: column;
                gap: 6px;
                flex: 1;
                min-width: 0;
            }

            .norma-card__title {
                font-size: 15px;
                font-weight: 600;
                color: #0f172a;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .norma-card__meta {
                font-size: 13px;
                color: #64748b;
                line-height: 1.4;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .norma-card__status {
                display: flex;
                justify-content: flex-start;
            }
        }

        .norma-checkbox {
            position: absolute;
            opacity: 0;
            pointer-events: none;
        }

        .tag {
            display: inline-flex;
            align-items: center;
            padding: 4px 10px;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 600;
            letter-spacing: 0.3px;
            text-transform: uppercase;
            background: rgba(148, 163, 184, 0.18);
            color: #475569;

            &.tag-warning {
                background: rgba(245, 158, 11, 0.18);
                color: #b45309;
            }
        }

        .btn-modern-primary {
            border: none;
            border-radius: 12px;
            padding: 14px 20px;
            font-weight: 700;
            letter-spacing: 0.3px;
            text-transform: uppercase;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
            color: #ffffff !important;
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
                color: #ffffff !important;
            }

            &:active {
                transform: translateY(0);
            }
        }

        .empty-state {
            border-radius: 18px;
            border: 1.5px dashed rgba(148, 163, 184, 0.4);
            background: rgba(248, 250, 252, 0.85);
            padding: 32px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            text-align: center;
            color: #475569;

            h5 {
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: #0f172a;
            }

            p {
                margin: 0;
                font-size: 13px;
                max-width: 320px;
                line-height: 1.5;
            }

            .empty-icon {
                width: 72px;
                height: 72px;
                border-radius: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(96, 165, 250, 0.14) 0%, rgba(56, 189, 248, 0.14) 100%);
                color: #2563eb;
            }
        }

        .btn-md {
            z-index: 1001;
        }

        @media (max-width: 768px) {
            .modal-modern-header,
            .modal-modern-body,
            .modal-modern-footer {
                padding: 24px 20px;
            }

            .modal-modern-header {
                flex-direction: column;
                align-items: stretch;
                gap: 14px;

                &::after {
                    left: 20px;
                    right: 20px;
                }

                .header-icon {
                    width: 56px;
                    height: 56px;
                }
            }
        }

        @media (max-width: 576px) {
            .modal-dialog {
                margin: 12px;
            }

            .modal-modern-header .header-text {
                h2 {
                    font-size: 22px;
                }

                p {
                    font-size: 13px;
                }
            }
        }

    }

    :deep([data-bs-theme="dark"] .modern-modal) {
        .modal-modern-content {
            background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
        }

        .modal-modern-header {
            .header-icon {
                background: linear-gradient(135deg, rgba(96, 165, 250, 0.26) 0%, rgba(14, 165, 233, 0.26) 100%);
                color: #38bdf8;
            }

            .header-text {
                h2 {
                    color: #f8fafc;
                }

                p {
                    color: #94a3b8;
                }
            }
        }

        .form-label {
            color: #e2e8f0;
        }

        .form-control {
            background: rgba(15, 23, 42, 0.82);
            border-color: rgba(148, 163, 184, 0.2);
            color: #e2e8f0;

            &:focus {
                background: rgba(15, 23, 42, 0.95);
                color: #f8fafc;
            }
        }

        .norma-card {
            background: rgba(15, 23, 42, 0.82);
            border-color: rgba(148, 163, 184, 0.18);

            &:hover {
                border-color: rgba(96, 165, 250, 0.55);
                box-shadow: 0 16px 32px rgba(37, 99, 235, 0.15);
            }

            &--selected {
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(14, 165, 233, 0.18) 100%);
                border-color: rgba(56, 189, 248, 0.65);
            }

            .norma-card__title {
                color: #e2e8f0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .norma-card__meta {
                color: #94a3b8;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .norma-card__indicator {
                border-color: rgba(148, 163, 184, 0.28);
                background: rgba(15, 23, 42, 0.92);

                &.is-selected {
                    border-color: rgba(96, 165, 250, 0.75);
                    background: rgba(59, 130, 246, 0.26);
                    color: #60a5fa;
                }

                &.is-disabled {
                    border-color: rgba(148, 163, 184, 0.18);
                    color: #71717a;
                }
            }
        }

        .tag {
            background: rgba(148, 163, 184, 0.18);
            color: #cbd5f5;

            &.tag-warning {
                background: rgba(245, 158, 11, 0.18);
                color: #fbbf24;
            }
        }

        .empty-state {
            background: rgba(15, 23, 42, 0.74);
            border-color: rgba(148, 163, 184, 0.26);
            color: #94a3b8;

            h5 {
                color: #e2e8f0;
            }

            .empty-icon {
                background: linear-gradient(135deg, rgba(96, 165, 250, 0.18) 0%, rgba(56, 189, 248, 0.18) 100%);
                color: #38bdf8;
            }
        }

        .btn-md {
            background: rgba(15, 23, 42, 0.92) !important;
            border-color: rgba(148, 163, 184, 0.35) !important;

            svg {
                color: #e2e8f0;
            }
        }

        .btn-modern-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
        }
    }
</style>
